import { useTranslation } from "react-i18next";
import type { ScheduledEmailReport } from "../types";

interface StatusBadgeProps {
  status: ScheduledEmailReport["last_run_status"];
}

/**
 * Last-run status chip for scheduled email reports.
 * Uses the canonical `.score-badge.{success,warning,error}` palette from
 * `statsNew.css` so all chips across Stats share one visual language.
 */
const StatusBadge = ({ status }: StatusBadgeProps) => {
  const { t } = useTranslation();

  if (!status) {
    return (
      <span className="text-gray-400 text-xs">{t("pages.statistics.reports.status.never")}</span>
    );
  }

  const map: Record<string, { label: string; cls: string }> = {
    success: {
      label: t("pages.statistics.reports.status.success"),
      cls: "score-badge success",
    },
    partial_llm_failure: {
      label: t("pages.statistics.reports.status.partialLlm"),
      cls: "score-badge warning",
    },
    send_failure: {
      label: t("pages.statistics.reports.status.sendFailure"),
      cls: "score-badge error",
    },
  };

  const m = map[status];
  if (!m) return null;

  // font-normal overrides the .score-badge's 600 weight — kept local to the
  // reports list so we don't lighten the bolder Stats KPI badges that share
  // the same .score-badge class elsewhere.
  return <span className={`${m.cls} font-normal`}>{m.label}</span>;
};

export default StatusBadge;
